import React from 'react';
import PropTypes from 'prop-types';
import HomeFilterOptions from '../HomeFilterOptions';
import CollapsibleSection from '../CollapsibleSection';

class Filters extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleSectionToggle = (options) => {
    this.props.trackToggleFilterSection(options);

    const { filterId, isOpen } = options;
    this.setState({
      [filterId]: {
        isOpen,
      },
    });
  };

  getOpenState = (filter) => {
    if (this.state[filter.id]) {
      return this.state[filter.id].isOpen;
    }

    return filter.styling.web ? filter.styling.web.desktop.collapse === 'OPEN' : true;
  };

  render() {
    return this.props.filters.map((filter) => (
      <div key={filter.id}>
        <CollapsibleSection
          id={filter.id}
          heading={filter.header}
          isOpen={this.getOpenState(filter)}
          onClick={this.handleSectionToggle}
        >
          <HomeFilterOptions
            id="sidebar"
            filter={filter}
            setSelectedFilters={this.props.setSelectedFilters}
            selectedFilters={this.props.selectedFilters}
            hideHeader
            sidebarLayout
          />
        </CollapsibleSection>
      </div>
    ));
  }
}

Filters.propTypes = {
  /** Array of filters to render in the sidebar */
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      images: PropTypes.shape({
        icon: PropTypes.shape({
          name: PropTypes.string,
          image: PropTypes.string,
        }),
      }).isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          count: PropTypes.number,
          name: PropTypes.string.isRequired,
          selected: PropTypes.bool,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
      ).isRequired,
      styling: PropTypes.shape({
        mobile: PropTypes.shape({
          collapse: PropTypes.string,
          seperators: PropTypes.string,
        }),
        desktop: PropTypes.shape({
          collapse: PropTypes.string,
          seperators: PropTypes.string,
        }),
      }),
      optionsType: PropTypes.string.isRequired,
    }),
  ).isRequired,
  /** Array of filters that have been selected */
  selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,

  /** Callback to handle clicking on filters */
  setSelectedFilters: PropTypes.func.isRequired,

  /** Method that will fire tracking event when state of collapsible section is changed * */
  trackToggleFilterSection: PropTypes.func.isRequired,
};

export default Filters;
